import I18n from "components/materials/I18n";
import Typography, { ITypo } from "components/elements/Typography";
import InputElement, { EInputType } from "components/materials/Form/InputElement";
import { useCallback, useEffect, useState } from "react";
import classes from "./classes.module.scss";

export type IDemembrementKeyEdit = {
	duration: number;
	usufruitRatio: number;
	nueProprieteRatio: number;
};

type IProps = {
	keys: IDemembrementKeyEdit[];
	readonly: boolean;
	onChange?: (keys: IDemembrementKeyEdit[]) => void;
};

export default function DemembrementKeysTable({ keys, readonly, onChange }: IProps) {
	const [localKeys, setLocalKeys] = useState(keys);

	useEffect(() => {
		setLocalKeys(keys);
	}, [keys]);

	const handleInputChange = useCallback((index: number, percentStr: string) => {
		const pct = parseFloat(percentStr);
		if (isNaN(pct)) return;
		const usufruitRatio = Math.min(1, Math.max(0, pct / 100));
		setLocalKeys((prev) => prev.map((key, i) => (i === index ? { ...key, nueProprieteRatio: 1 - usufruitRatio } : key)));
	}, []);

	const handleBlur = useCallback(
		(index: number, percentStr: string) => {
			const pct = parseFloat(percentStr);
			if (isNaN(pct)) return;
			const usufruitRatio = Math.min(1, Math.max(0, pct / 100));
			setLocalKeys((prev) => {
				const updated = prev.map((key, i) => (i === index ? { ...key, usufruitRatio, nueProprieteRatio: 1 - usufruitRatio } : key));
				onChange?.(updated);
				return updated;
			});
		},
		[onChange],
	);

	if (!localKeys.length) return null;

	return (
		<div className={classes["root"]}>
			<Typography typo={ITypo.H2} className={classes["title"]}>
				{I18n.asset.pages.product.demembrement_keys.title}
			</Typography>
			<table className={classes["table"]}>
				<thead>
					<tr>
						<th className={classes["th"]}>{I18n.asset.pages.product.demembrement_keys.duration}</th>
						<th className={classes["th"]}>{I18n.asset.pages.product.demembrement_keys.usufruit}</th>
						<th className={classes["th"]}>{I18n.asset.pages.product.demembrement_keys.nue_propriete}</th>
					</tr>
				</thead>
				<tbody>
					{localKeys.map(({ duration, usufruitRatio, nueProprieteRatio }, index) => (
						<tr key={duration} className={classes["tr"]}>
							<td className={classes["td"]}>
								{duration} {I18n.asset.pages.product.demembrement_keys.years}
							</td>
							<td className={classes["td"]}>
								{readonly ? (
									`${(usufruitRatio * 100).toFixed(2)} %`
								) : (
									<InputElement
										type={EInputType.TEXT}
										name={`demembrementKeys.${index}.usufruitRatio`}
										min={0}
										max={100}
										defaultValue={(usufruitRatio * 100).toFixed(2)}
										onChange={(e) => handleInputChange(index, e.target.value)}
										onBlur={(e) => handleBlur(index, e.target.value)}
										size="small"
									/>
								)}
							</td>
							<td className={classes["td"]}>
								{`${(nueProprieteRatio * 100).toFixed(2)} %`}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
